import { createApp } from 'vue';
import { createGtag } from 'vue-gtag';
import App from './app.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import './styles/main.scss';

const { VUE_APP_GTAG_ID } = process.env;

const app = createApp(App);

app.use(router);
app.use(store);
if (VUE_APP_GTAG_ID) {
  app.use(createGtag({ tagId: VUE_APP_GTAG_ID, pageTracker: { router } }));
}

router.isReady().then(() => {
  app.mount('#app');
  document.dispatchEvent(new Event('x-app-rendered'));
});
